import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onSearchDialogInputClicked = ({
	attributes,
	nonPrivacySafeAttributes,
}: {
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'ui',
	action: 'clicked',
	actionSubject: 'searchDialogInput',
	attributes,
	nonPrivacySafeAttributes,
});
